/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-editor',
    templateUrl: './editor.component.html',
    styleUrls: ['./editor.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class EditorComponent {
    /**
     * Set the form group
     * @param formGroup
     */
    @Input() set formGroup(formGroup) {
        this._formGroup = formGroup;
    }

    /**
     * Editor control name.
     */
    @Input() public editorControlName: string;

    /**
     * Editor styles.
     */
    @Input() public editorStyles: any = {
        width: '100%',
        height: '100px'
    };

    /**
     * Get formGroup.
     */
    get formGroup() {
        return this._formGroup;
    }

    /**
     * Quill editor config.
     */
    public quillConfiguration: any = null;

    /**
     * Form group.
     * @private
     */
    private _formGroup: FormGroup = new FormGroup({ editor: new FormControl('') });

    constructor() {
        this.quillConfiguration = this.getRichTextConfig();
    }

    /**
     * Rich text editor config.
     * @private
     */
    private getRichTextConfig(): any {
        return {
            syntax: false,
            toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ 'header': [1, 2, 3, 4, false] }],
                ['link'],
                ['clean']
            ]
        };
    }
}
